import React from 'react';
import Form from './form';
import { FormModal, FormModalButton } from './FormModal';

const FormRenderer = (function () {
  function displayFor(article, position) {
    const formForPosition = article.articleForms.filter((form) => form.position === position)[0];

    if (!formForPosition) return null;

    const formId = formForPosition.form_base_id;
    const contentArticleFormId = formForPosition.id;
    const articleId = article.id;

    return (
      <Form formId={formId} contentArticleFormId={contentArticleFormId} articleId={articleId} />
    );
  }

  function formWithId(formId, contentArticleFormId = null) {
    return <Form formId={formId} contentArticleFormId={contentArticleFormId} />;
  }

  function formInModal(article, position) {
    const formForModal = article.articleForms.filter((form) => form.position === position)[0];

    if (!formForModal) return null;

    const modalId = `form-modal-${formForModal.form_base_id}-for-article-${article.id}`;

    return (
      <div>
        <FormModal id={modalId} article={article} position={position} />
        <FormModalButton id={modalId} buttonText={formForModal.additional} />
      </div>
    );
  }

  /**
   * Determine, if check boxes of a fieldset have `min_required` set and apply a logic
   * for the frontend to need to select the given number.
   * Only check for min_required if form is a newsletter registration form and not a
   * newsletter cancellation form (isNewsletterSubscription).
   *
   * @param {number} formId id of the form
   * @param {number} contentArticleFormId id of the connection of content_article and form
   * @param {object} fieldsets all fieldsets of a form with every fields to loop over
   */
  function initMinRequired(formId, contentArticleFormId, fieldsets) {
    const isNewsletterSubscription = document.getElementById(`content_article_form-${contentArticleFormId}-newsletter_subscription-${formId}`);
    const hasMinRequired = (options) => options && {}.hasOwnProperty.call(options, 'min_required');
    const hasMinOneChecked = (options) => options && {}.hasOwnProperty.call(options, 'check_automatically');
    const hiddenDiv = document.createElement('div');
    hiddenDiv.setAttribute('style', 'line-height: 0px; height: 0px;');
    hiddenDiv.innerHTML = '<input type="radio" name="hidden" value="on" required>';
    const hiddenRequiredInput = hiddenDiv.querySelector('input');

    for (const fieldset of fieldsets) {
      for (const field of fieldset.fields) {
        if (field.field_type === 'check_box' && hasMinRequired(field.options) && isNewsletterSubscription) {
          // console.log('check box with min_required found for fieldset', fieldset.id, fieldset);
          // console.log('with form id', formId, contentArticleFormId);

          // TODO: the number of minimum required elements is not considered yet
          // const minRequired = field.options.min_required;
          const form = document.getElementById(
            `content_article_form-${contentArticleFormId}-form_bases-${formId}`
          );
          const checkBoxGroup = form.querySelector(`.fieldset-${fieldset.id}`);
          const checkBoxes = checkBoxGroup.querySelectorAll('.checkbox');
          checkBoxGroup.insertBefore(hiddenDiv, checkBoxes[0]);

          for (let i = checkBoxes.length - 1; i >= 0; i--) {
            checkBoxes[i].addEventListener('click', () => {
              if (checkBoxGroup.querySelectorAll('input:checked').length > 0) {
                hiddenDiv.style.display = 'none';
                hiddenRequiredInput.removeAttribute('required');
              } else {
                hiddenDiv.style.display = 'block';
                hiddenRequiredInput.setAttribute('required', '');
              }
            });
          }

          // we only need to do this once for a check box group, so we can leave the loop here
          break;
        }
      }
    }

    for (const fieldset of fieldsets) {
      for (const field of fieldset.fields) {
        if (field.field_type === 'check_box' && hasMinRequired(field.options) && isNewsletterSubscription) {
          if (hasMinOneChecked(field.options) && field.options.check_automatically) {
            hiddenDiv.style.display = 'none';
            hiddenRequiredInput.removeAttribute('required');

            // we only need to do this once for a check box group, so we can leave the loop here
            break;
          }
        }
      }
    }
  }

  return {
    displayFor,
    formWithId,
    formInModal,
    initMinRequired
  };
})();

export default FormRenderer;



// WEBPACK FOOTER //
// ./components/forms/formRenderer.js